import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {UserLangResolverService} from '../../../services/user-lang-resolver';
import {environment} from '../../../../environments/environment';
import {AuthControllerService} from "../../../services/auth-controller/auth-controller.service";
import {AuthRESTService} from '../../services/rest/auth-rest.service';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class HeaderWidget implements OnInit {

    serviceId: string;
    showNotVerifiedMessage: boolean;
    verificationMessage: string;
    OAuthClientId: string = environment.OAuthClientId;
    OAuthRedirectUrl: string = environment.OAuthRedirectUrl;
    randomHash: string;
	  userLangResolver: UserLangResolverService;
    casBaseUrl: string = environment.casBaseUrl;

    constructor(private activatedRoute: ActivatedRoute,
                public translate: TranslateService,
                private authService: AuthControllerService,
				private router: Router, userLangResolver: UserLangResolverService,
				private rest: AuthRESTService) {
					this.userLangResolver = userLangResolver;
          this.randomHash = this.authService.randomId();
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.serviceId = params['serviceId'];
		});
		this.initAfterUserLoad = this.initAfterUserLoad.bind(this);
		this.authService.subscribeForTokenChange(this.initAfterUserLoad);

	}

	ngOnDestroy(): void {
		this.authService.unsubscribe(this.initAfterUserLoad);
	}

    initAfterUserLoad() {
        if (this.authService.isSavedTokenValid()) {
            const userVerified = this.authService.isUserVerified();
            const userEmailVerified = this.authService.isUserEmailVerified();
            this.showNotVerifiedMessage = HeaderWidget.showVerificationWarning(userVerified, userEmailVerified);
            this.verificationMessage = HeaderWidget.getVerificationMessage(userVerified,
				userEmailVerified);
        }
    }

    public static showVerificationWarning(userVerified: boolean, userEmailVerified: boolean) {
        return !userVerified || !userEmailVerified;
    }

    public static getVerificationMessage(isUserVerified, isUserEmailVerified){
        if (!isUserVerified && !isUserEmailVerified) {
            return 'Email and user not verified';
        }
        if (!isUserVerified) {
            return 'User not yet verified';
        }
        return 'Email not yet verified';
    }

    onLogout() {
        this.authService.logout().subscribe();
    }

    getName(): string {
        const savedTokenValid = this.authService.isSavedTokenValid();
        if(!savedTokenValid){
            return "not_logged_in";
        }
		const user = this.authService.loggedUser();
		if (!user) return "";
        return user.fname + ' ' + user.lname;
    }
}
